import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { checkArray } from '../../../../Components/helper';
import LibraryFilter from './LibraryFilter';
import * as action from '../Store/CustomModule.action';
import '../CustomModule.css';
import LibraryCard from '../Library/LibraryCard';
import Loader from '../../../../Components/Utility/Loader/Loader';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';

function List() {
  const dispatch = useDispatch();
  const reducerState = useSelector((redState) => redState);
  const { CustomModuleReducer, Users, SystemMastersDetails } = reducerState;
  const { subBrandAccess } = SystemMastersDetails;
  const { customGroupList } = CustomModuleReducer;
  const { logInRights } = Users;
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    isLoading: false,
    searchText: '',
    groupList: [],
    pageSize: 20,
    pageIndex: 1,
    groupTotalCount: 0,
    selectedGroups: [],
    deleteModal: false,
    hasMoreData: false,
    activeInactiveModal: false,
  });
  const { isLoading, searchText, pageSize, pageIndex, groupTotalCount, groupList, selectedGroups, deleteModal, hasMoreData, activeInactiveModal } = state;
  const isallChecked = checkArray(groupList) && selectedGroups.length === groupList.length;
  const { CheckActionPermission } = useComponent();
  const CustomAddEditAccess = CheckActionPermission(logInRights, 'libraries', 'customModule', 'addEdit');
  const CustomDeleteAccess = CheckActionPermission(logInRights, 'libraries', 'customModule', 'delete');
  useEffect(() => {
    const init = async () => {
      setState((prevState) => ({
        ...prevState,
        isLoading: true,
      }));
      await dispatch(action.getAllCustomModuleGroup({ pageSize: 20, pageIndex: 1 }));
      await dispatch(systemMasterAction.getSubBrandAccess());
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    };

    init();
    return () => {
      dispatch(action.UNMOUNT_GROUP_LIST());
    };
  }, []);

  useEffect(() => {
    if (checkArray(customGroupList?.doc)) {
      setState((prevState) => ({
        ...prevState,
        groupList: [...groupList, ...(customGroupList?.doc || [])],
        groupTotalCount: customGroupList?.totalCount,
        hasMoreData: customGroupList?.totalCount > 20,
      }));
    }
  }, [customGroupList]);

  const handleNextPagesInScroll = async () => {
    setState((prevState) => ({
      ...prevState,
      pageIndex: pageIndex + 1,
    }));
    const typeObj = {
      pageSize,
      pageIndex: pageIndex + 1,
    };
    if (searchText !== '') {
      typeObj.searchText = searchText;
    }

    if (!groupList.length < groupTotalCount) {
      setState((prevData) => ({
        ...prevData,
        hasMoreData: false,
      }));
    }
  };

  const handleCheckLibrary = async (isLibChecked, libId) => {
    const existingIds = selectedGroups;
    if (isLibChecked && !existingIds.includes(libId)) {
      setState((prevState) => ({
        ...prevState,
        selectedGroups: [...existingIds, libId],
      }));
    } else {
      const removedArray = existingIds?.filter((eleId) => eleId !== libId);

      if (checkArray(removedArray)) {
        setState((prevState) => ({
          ...prevState,
          selectedGroups: removedArray,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          selectedGroups: [],
        }));
      }
    }
  };
  const handleDeleteById = (libId) => {
    setState((prevState) => ({
      ...prevState,
      selectedGroups: [libId],
      deleteModal: true,
    }));
  };

  const handleCheckAll = async (e) => {
    if (e.target.checked) {
      const allIds = groupList && checkArray(groupList) && groupList.map((ele) => ele._id);

      if (allIds) {
        setState((prevState) => ({
          ...prevState,
          selectedGroups: allIds.filter((element) => element !== undefined),
        }));
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        selectedGroups: [],
      }));
    }
  };

  const handleCloseDeleteModal = () => {
    setState((prevState) => ({
      ...prevState,
      selectedGroups: [],
      deleteModal: false,
    }));
  };

  const handleCloseActiveInactiveModal = () => {
    setState((prevState) => ({
      ...prevState,
      selectedGroups: [],
      activeInactiveModal: false,
    }));
  };

  const handleDelete = () => {
    setState((prevState) => ({
      ...prevState,
      deleteModal: true,
    }));
  };

  const handleLibrarySearchText = async (librarySearchText) => {
    setState((prevState) => ({
      ...prevState,
      searchText: librarySearchText,
    }));
  };

  const handleSearchSubmit = async (event) => {
    if (event.key === 'Enter' && !isLoading) {
      // Perform your desired action here
      setState((prevState) => ({
        ...prevState,
        groupList: [],
        pageIndex: 1,
        isLoading: true,
      }));
      const typeObj = {
        searchText: searchText.trim(),
        pageSize,
        pageIndex: 1,
      };
      const res = await dispatch(action.getAllCustomModuleGroup(typeObj));
      if (res?.code === 200) {
        setState((prevState) => ({
          ...prevState,
          isLoading: false,
        }));
      }
    }
  };

  const confirmDelete = async () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      groupList: [],
    }));
    const res = await dispatch(action.deleteCustomModuleGroup(selectedGroups, t));
    if (res.code === 200) {
      dispatch(action.getAllCustomModuleGroup({ pageSize: 20, pageIndex: 1 }));
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        deleteModal: false,
        selectedGroups: [],
      }));
    }
  };

  const handleActiveInactiveId = (grpId) => {
    setState((prevState) => ({
      ...prevState,
      selectedGroups: [grpId],
      activeInactiveModal: true,
    }));
  };

  const confirmActiveInactive = async () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      groupList: [],
    }));

    try {
      const selectedGroup = groupList.find((ele) => ele._id === selectedGroups[0]);

      // Additional validation for selected group
      if (!selectedGroup) {
        console.error(t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.SELECTED_GROUP_NOT_FOUND'));
        setState((prevState) => ({
          ...prevState,
          isLoading: false,
          activeInactiveModal: false,
        }));
        return;
      }

      const objData = {
        _id: selectedGroups[0],
        isActive: !selectedGroup.isActive,
      };

      const res = await dispatch(action.activeInactiveCustomModuleGroup(objData, t));

      // Comprehensive response handling
      if (res && res.code === 200 && !res.error) {
        // Maintain current pagination instead of resetting to page 1
        await dispatch(
          action.getAllCustomModuleGroup({
            pageSize,
            pageIndex,
          }),
        );

        setState((prevState) => ({
          ...prevState,
          isLoading: false,
          activeInactiveModal: false,
          selectedGroups: [],
        }));
      } else {
        // Handle different error scenarios - action already shows toaster message
        console.error('Error updating group status:', res?.message || 'Unknown error');

        setState((prevState) => ({
          ...prevState,
          isLoading: false,
          activeInactiveModal: false,
        }));
      }
    } catch (error) {
      console.error('Error in confirmActiveInactive:', error);
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        activeInactiveModal: false,
      }));
    }
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.CUSTOM_MODULE_GROUP')}</h4>
        </div>
        <LibraryFilter
          selectedLibrary={selectedGroups}
          handleDelete={handleDelete}
          handleCheckAll={handleCheckAll}
          isallChecked={isallChecked}
          handleLibrarySearchText={handleLibrarySearchText}
          handleSearchSubmit={handleSearchSubmit}
          searchText={searchText}
          CustomAddEditAccess={CustomAddEditAccess}
          CustomDeleteAccess={CustomDeleteAccess}
        />
      </div>
      <Container fluid>
        <Row>
          <Col md={12} className="py-3">
            <div className="d-flex justify-content-end">
              <Link className="btn btn-default px-2 text-decoration-none" to="/libraries/custom-module/library">
                {t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.CUSTOM_MODULE_LIBRARY')}
              </Link>
              <button type="button" className="btn btn-default active ml-2  px-2">
                {t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.CUSTOM_MODULE_GROUPS')}
              </button>
            </div>
          </Col>
        </Row>
        {isLoading ? (
          <Loader />
        ) : (
          <InfiniteScroll
            dataLength={groupList.length} // This is important field to render the next data
            next={handleNextPagesInScroll}
            hasMore={hasMoreData}
            loader={hasMoreData && <Loader />}
          >
            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1440: 4 }}>
              <Masonry className="custom-masonry custom-container " gutter="30px">
                {checkArray(groupList) &&
                  groupList.map((ele, i) => {
                    return (
                      <LibraryCard
                        key={ele}
                        handleDeleteById={handleDeleteById}
                        selectedItems={selectedGroups}
                        handleCheckLibrary={handleCheckLibrary}
                        ele={ele}
                        i={i}
                        isFromGroup
                        CustomAddEditAccess={CustomAddEditAccess}
                        CustomDeleteAccess={CustomDeleteAccess}
                        subBrandAccess={subBrandAccess}
                        handleActiveInactiveId={handleActiveInactiveId}
                      />
                    );
                  })}
              </Masonry>
            </ResponsiveMasonry>
            {groupList.length === 0 && <p className="text-center">{t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.NO_CUSTOM_MODULE_FOUND')}</p>}
          </InfiniteScroll>
        )}
      </Container>
      {deleteModal && (
        <ConfirmationPopup
          onOpen={deleteModal}
          onConfirm={() => confirmDelete()}
          title={t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.DELETE_MODULE_GROUP')}
          message={t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.SELECTED_GROUP_MESSAGE')}
          toggle={() => handleCloseDeleteModal()}
        />
      )}
      {activeInactiveModal && (
        <ConfirmationPopup
          onOpen={activeInactiveModal}
          onConfirm={() => confirmActiveInactive()}
          title={t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.ACTIVE_MODULE_GROUP')}
          message={t('CUSTOM_MODULES.GROUP.CUSTOM_LIST.ACTIVE_MESSAGE')}
          toggle={() => handleCloseActiveInactiveModal()}
        />
      )}
    </>
  );
}

export default List;
